export const CLIENT_URL_PARAM = 'client';
export const SECTION_URL_PARAM = 'section';

export const CLIENT_DETAIL_SECTIONS = ['access', 'views', 'permissions', 'users'] as const;
export type ClientDetailSection = (typeof CLIENT_DETAIL_SECTIONS)[number];

export function readClientDetailSection(params: URLSearchParams): ClientDetailSection {
  const section = params.get(SECTION_URL_PARAM);
  if (section && (CLIENT_DETAIL_SECTIONS as readonly string[]).includes(section)) {
    return section as ClientDetailSection;
  }
  return 'access';
}

export function stripClientDetailParams(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete(CLIENT_URL_PARAM);
  next.delete(SECTION_URL_PARAM);
  return next;
}
